import React from "react";
import {
  Box,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,

} from "@mui/material";


interface Column  {
  key: string;
  label: string;
  align?: "left" | "right" | "center";
  render?: (row: any) => React.ReactNode;
}

interface ReusableTableProps {
  columns: Column[];
  data: any[];
  page: number;
  limit: number;
  total: number;
  isShow?: boolean;

  onPageChange: (event: unknown, newPage: number) => void;
  onLimitChange: (event: React.ChangeEvent<HTMLInputElement>) => void;

  selectable?: boolean;
  selected?: (string | number)[];
  onSelectAll?: (checked: boolean) => void;
  onSelectOne?: (id: string | number) => void;

  actions?: (row: any) => React.ReactNode;
}

const Tables: React.FC<ReusableTableProps> = ({
  columns,
  data,
  page,
  limit,
  total,
  onPageChange,
  onLimitChange,
  selectable = false,
  selected = [],
  onSelectAll,
  onSelectOne,
  actions,
  isShow = true
}) => {
  const allSelected = selectable && data.length > 0 && selected?.length === data.length;
  const someSelected = selectable && selected?.length > 0 && selected.length < data.length;

  return (
    <Box>
      <TableContainer sx={{ maxHeight: 600, overflow: "auto" }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {selectable && (
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={allSelected}
                    indeterminate={someSelected}
                    onChange={(e) => onSelectAll?.(e.target.checked)}
                  />
                </TableCell>
              )}

              {columns.map((col) => (
                <TableCell key={col.key} align={col.align || "left"}>
                  {col.label}
                </TableCell>
              ))}

              {actions && (
                <TableCell align="right">Actions</TableCell>
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {data?.map((row) => (
              <TableRow key={row.id} hover>
                {selectable && (
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selected?.includes(row.id)}
                      onChange={() => onSelectOne?.(row.id)}
                    />
                  </TableCell>
                )}

                {columns.map((col) => (
                  <TableCell key={col.key} align={col.align || "left"}>
                    {col.render ? col.render(row) : row[col.key]}
                  </TableCell>
                ))}

                {actions && (
                  <TableCell align="right">
                    {actions(row)}
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>

        </Table>
      </TableContainer>
{ isShow === false ? (""):(
      <Box p={2}>
        <TablePagination
          component="div"
          count={total}
          onPageChange={onPageChange}
          onRowsPerPageChange={onLimitChange}
          page={page}
          rowsPerPage={limit}
          rowsPerPageOptions={[5, 10,]}
        />
      </Box>
      )}
    </Box>
  );
};

export default Tables;
